import { apiURLNew, callAPI, getEventId } from 'api/main';

import { middlewareProspection } from './middleware';

interface IGetProspectionParams {
  tags: string[];
  page: number;
}

interface IProspectionResponse {
  nextPage: number | null;
  data: IProspection[];
}

export default async ({ tags, page }: IGetProspectionParams): Promise<IProspectionResponse> => {
  try {
    const res = await callAPI({
      url: `${apiURLNew}/matchs/v1/prospection/`,
      method: 'GET',
      needToken: true,
      isLegacy: false,
      params: {
        'filter[survey_question_choice_id]': tags.join(','),
        event_id: getEventId(),
        per_page: 100,
        page,
      },
    });

    const { data, pagination } = res.request;

    if (data) {
      return {
        nextPage: pagination?.next_page || null,
        data: middlewareProspection(data),
      };
    }

    return {
      nextPage: null,
      data: [],
    };
  } catch (ex) {
    return {
      nextPage: null,
      data: [],
    };
  }
};
